module.exports = __webpack_public_path__ + "static/media/yash_hodlur.7f1cc047.png";